// import $electron from 'electron'

let $electron;
let isElc = false

try {
    $electron    = window.require('electron');
    window.isElc = isElc = true;
} catch (e) {}

export default {
    send(name, data) {
        if (isElc) $electron.ipcRenderer.send(name, data)
    },
    on(name, data) {
        if (isElc) $electron.ipcRenderer.on(name, data)
    },
    remove(data) {
        if (isElc) $electron.ipcRenderer.send(data)
    }
}



// WEBPACK FOOTER //
// ./src/mixin/ipcRender.js